import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import SeriesPage from "@/pages/SeriesPage";
import SectionPage from "@/pages/SectionPage";
import ArticlePage from "@/pages/ArticlePage";
import CodexPage from "@/pages/CodexPage";
import MapPage from "@/pages/MapPage";
import VaultPage from "@/pages/VaultPage";
import { PageState } from "@/pages/PageState";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminArticles from "@/admin/AdminArticles";
import ArticleEditor from "@/admin/ArticleEditor";
import AdminSections from "@/admin/AdminSections";
import AdminSeries from "@/admin/AdminSeries";
import AdminSettings from "@/admin/AdminSettings";
import AdminSubmissions from "@/admin/AdminSubmissions";
import AdminVault from "@/admin/AdminVault";
import AdminUsers from "@/admin/AdminUsers";
import AdminSecurity from "@/admin/AdminSecurity";
import AdminWording from "@/admin/AdminWording";
import AdminCustom from "@/admin/AdminCustom";
import AdminTemplates from "@/admin/AdminTemplates";
import AdminLinks from "@/admin/AdminLinks";
import AdminNewsletter from "@/admin/AdminNewsletter";
import NewsletterActionPage from "@/components/Newsletter";
import JoinPage from "@/pages/JoinPage";
import ContributePage, { ContributeEditor } from "@/pages/ContributePage";
import PreviewPage from "@/pages/PreviewPage";
import ReaderProfilePage from "@/pages/ReaderProfilePage";
import LegalPage from "@/pages/LegalPage";
import { SpoilerProvider } from "@/context/SpoilerContext";

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <SpoilerProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="series/:slug" element={<SeriesPage />} />
              <Route path="section/:slug" element={<SectionPage />} />
              <Route path="wiki/:slug" element={<ArticlePage />} />
              <Route path="codex" element={<CodexPage />} />
              <Route path="map" element={<MapPage />} />
              <Route path="vault" element={<VaultPage />} />
              <Route path="join" element={<JoinPage />} />
              <Route path="contribute" element={<ContributePage />} />
              <Route path="contribute/new" element={<ContributeEditor />} />
              <Route path="contribute/:id" element={<ContributeEditor />} />
              <Route path="preview/:id" element={<PreviewPage />} />
              <Route path="reader/:slug" element={<ReaderProfilePage />} />
              <Route path="legal/:key" element={<LegalPage />} />
              <Route path="newsletter/:action" element={<NewsletterActionPage />} />
              <Route path="*" element={<PageState />} />
            </Route>
            <Route path={process.env.REACT_APP_ADMIN_PATH.replace(/^\//, "")} element={<AdminLogin />} />
            <Route path="admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="articles" element={<AdminArticles />} />
              <Route path="articles/new" element={<ArticleEditor />} />
              <Route path="articles/:id" element={<ArticleEditor />} />
              <Route path="submissions" element={<AdminSubmissions />} />
              <Route path="vault" element={<AdminVault />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="security" element={<AdminSecurity />} />
              <Route path="wording" element={<AdminWording />} />
              <Route path="custom" element={<AdminCustom />} />
              <Route path="templates" element={<AdminTemplates />} />
              <Route path="links" element={<AdminLinks />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="sections" element={<AdminSections />} />
              <Route path="series" element={<AdminSeries />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </SpoilerProvider>
        <Toaster position="bottom-right" richColors />
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
